import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function ReferencesPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>References</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              <ol>
                <li>
                  Adekola O, Mitchell G and Grainger A. 2015.{" "}
                  <strong>
                    Inequality and ecosystem services: The value and social
                    distribution of Niger Delta wetland services
                  </strong>
                  . <em>Ecosystem Services</em> <strong>12</strong>: 42-54.
                </li>
                <li>
                  Adekola O, Morardet S, de Groot R. <em>et al</em>{" "}
                  <strong>
                    The economic and livelihood value of provisioning services
                    of the Ga-Mampa wetland, South Africa
                  </strong>
                  .{" "}
                  <em>
                    In 13<sup>th</sup> IWRA World Water Congress
                  </em>
                  , pp. 1-24.
                </li>
                <li>
                  Anitha V and Muraleedharan P K. 2006.{" "}
                  <strong>
                    Economic valuation of ecotourism development of a
                    recreational site in the natural forests of southern Western
                    Ghats
                  </strong>
                  . <em>Kerala Forest Research Institute, </em> 1-116.
                  Peechi&ndash;680.
                </li>
                <li>
                  Anshumali and Ramanathan A L. 2007.{" "}
                  <strong>
                    Seasonal variation in the major ion chemistry of Pandoh
                    lake, Mandi district, Himachal Pradesh, India
                  </strong>
                  . <em>Applied Geochemistry</em> <strong>22</strong>(8):
                  1736-1747.
                </li>
                <li>
                  Aryal K, Ojha B R and Maraseni T. 2021.{" "}
                  <strong>
                    Perceived importance and economic valuation of ecosystem
                    services in Ghodaghodi wetland of Nepal
                  </strong>
                  . <em>Land Use Policy</em> <strong>106</strong>: 1-12.
                </li>
                <li>
                  Asulabha K S, Jaishanker R, Sincy V. <em>et al</em>{" "}
                  <strong>
                    Diversity of phytoplankton in lakes of Bangalore, Karnataka,
                    India
                  </strong>
                  . <em>Biodiversity Challenges &ndash; A Way Forward</em>, pp.
                  147-178. Daya Publishing House, New Delhi.
                </li>
                <li>
                  Asulabha K S, Sincy V, Jaishanker R. <em>et al</em>{" "}
                  <strong>
                    Algal diversity in urban lakes of Vrishabhavathi valley,
                    Greater Bangalore
                  </strong>
                  . Paper presented at the <em>LAKE 2018:</em>{" "}
                  <em>
                    The 11<sup>th</sup> Biennial Lake Conference
                  </em>
                  , Alva Campus, D.K. Dist., Karnataka, India.
                </li>
                <li>
                  Baral S, Basnyat B, Khanal R. <em>et al</em>{" "}
                  <strong>
                    A total economic valuation of wetland ecosystem services: An
                    evidence from Jagadishpur Ramsar site, Nepal
                  </strong>
                  . <em>The Scientific World Journal</em> <strong>2016</strong>:
                  1-10.
                </li>
                <li>
                  Barbier E B. 2013.{" "}
                  <strong>
                    Valuing ecosystem services for coastal wetland protection
                    and restoration: Progress and challenges
                  </strong>
                  . <em>Resources</em> <strong>2</strong>(3): 213-230.
                </li>
                <li>
                  Bengani R, Ujjania N C, Sangani K. <em>et al</em>{" "}
                  <strong>
                    Idol Immersion and its consequences on water quality of Tapi
                    River, Surat (Gujarat)
                  </strong>
                  .{" "}
                  <em>
                    International Journal of Advanced Research in Biological
                    Sciences
                  </em>{" "}
                  <strong>7</strong>(10): 137-144.
                </li>
                <li>
                  Bhattacharya S, Bera A, Dutta A. <em>et al</em>{" "}
                  <strong>
                    Effects of idol immersion on the water quality parameters of
                    Indian water bodies: Environmental health perspectives
                  </strong>
                  .{" "}
                  <em>
                    International Letters of Chemistry, Physics and Astronomy
                  </em>{" "}
                  <strong>39</strong>: 234-263.
                </li>
                <li>
                  Borah M P and Prasad S B. 2016.{" "}
                  <strong>
                    Ethnozoological remedial uses by the indigenous inhabitants
                    in adjoining areas of Pobitora wildlife sanctuary, Assam.
                    India
                  </strong>
                  .{" "}
                  <em>
                    International Journal of Pharmacy and Pharmaceutical
                    Sciences
                  </em>{" "}
                  <strong>8</strong>(4): 1-7.
                </li>
                <li>
                  Branco-Vieira M, Mata T M, Martins A A. <em>et al</em>{" "}
                  <strong>
                    Economic analysis of microalgae biodiesel production in a
                    small-scale facility
                  </strong>
                  . <em>Energy Reports</em> <strong>6</strong>: 325-332.
                </li>
                <li>
                  Burman P D, Cajee L and Laloo D D. 2007.{" "}
                  <strong>
                    Potential for cultural and eco-tourism in North East India:
                    A community-based approach
                  </strong>
                  . <em>WIT Transactions on Ecology and the Environment</em>{" "}
                  <strong>102</strong>: 715 - 724.
                </li>
                <li>
                  Chai T T, Ooh K F, Quah Y. <em>et al</em>{" "}
                  <strong>
                    Edible freshwater macrophytes: A source of anticancer and
                    antioxidative natural products - A mini-review
                  </strong>
                  . <em>Phytochemistry Reviews</em> <strong>14</strong>(3):
                  443-457.
                </li>
                <li>
                  Chaudhry P, Bhargava R, Sharma M P. <em>et al</em>{" "}
                  <strong>
                    Conserving urban lakes for tourism and recreation in
                    developing countries: A case from Chandigarh, India
                  </strong>
                  .{" "}
                  <em>
                    International Journal of Leisure and Tourism Marketing
                  </em>{" "}
                  <strong>3</strong>(3): 267-281.
                </li>
                <li>
                  Chisti Y. 2008.{" "}
                  <strong>Biodiesel from microalgae beats bioethanol</strong>.{" "}
                  <em>Trends in Biotechnology</em> <strong>26</strong>: 126-131.
                </li>
                <li>
                  Available at &lt;https://www.cices.eu &gt; last accessed on 13
                  July 2021.
                </li>
                <li>
                  Clarkson B R, Ausseil A G E and Gerbeaux P. 2013.{" "}
                  <strong>
                    Wetland ecosystem services. Ecosystem services in New
                    Zealand: Conditions and trends
                  </strong>
                  . pp. 192-202. Manaaki Whenua Press, Lincoln.
                </li>
                <li>
                  Costanza R, d'Arge R, de Groot R. <em>et al</em>{" "}
                  <strong>
                    The value of the world's ecosystem services and natural
                    capital
                  </strong>
                  . <em>Nature</em>, <strong>387</strong>(6630): 253-260.
                </li>
                <li>
                  Dasgupta S and Panigrahi A K R. 2014.{" "}
                  <strong>
                    Studies on the effect of aquatic pollution on ichthyofaunal
                    diversity of the East Kolkata wetlands
                  </strong>
                  .{" "}
                  <em>
                    International Journal of Research in Applied, Natural and
                    Social Sciences
                  </em>{" "}
                  <strong>2</strong>(4): 145-152.
                </li>
                <li>
                  de Groot R, Brander L and Solomonides S. 2020.{" "}
                  <strong>
                    Update of global ecosystem service valuation database (ESVD)
                  </strong>
                  . <em>FSD report No 2020-06 Wageningen</em>, pp. 1-58. The
                  Netherlands.
                </li>
                <li>
                  de Groot R, Brander L, Van Der Ploeg S. <em>et al</em>
                  <strong>
                    {" "}
                    Global estimates of the value of ecosystems and their
                    services in monetary units
                  </strong>
                  . <em>Ecosystem Services</em> <strong>1</strong>(1): 50-61.
                </li>
                <li>
                  Dehlavi A and Adil I H. 2011.{" "}
                  <strong>
                    Valuing the recreational uses of Pakistan&rsquo;s wetlands:
                    An application of the travel cost method
                  </strong>
                  .{" "}
                  <em>
                    Working Paper-58, South Asian Network for Development and
                    Environmental Economics
                  </em>
                  , pp. 1-38. Kathmandu.
                </li>
                <li>
                  Dixit A M, Bandyopadhyaya S, Kumar L. <em>et al</em>{" "}
                  <strong>
                    Economic valuation of landscape level wetland ecosystem and
                    its services in Little Rann of Kachchh, Gujarat
                  </strong>
                  .{" "}
                  <em>
                    The Economics of Ecosystems and Biodiversity India
                    Initiative
                  </em>{" "}
                  GIZ India, pp. 1-160.
                </li>
                <li>
                  <strong>Ecosystem Services Valuation Database (ESVD)</strong>{" "}
                  Available at &lt;https://esvd.net &gt;, last accessed on 21
                  January 2022.
                </li>
                <li>
                  Elaigwu A M, Oladele A H and Umaru J. 2019.{" "}
                  <strong>
                    Protein, energy and micronutrient of five different fishes
                    from Tiga reservoir, Nigeria
                  </strong>
                  . <em>Asian Journal of Fisheries and Aquatic Research</em>{" "}
                  <strong>3</strong>(2): 1-9.
                </li>
                <li>
                  Gogoi C and Bora M. 2020.{" "}
                  <strong>
                    Zoo-therapeutic practices among the deori tribes of Dhemaji
                    district, Assam, India
                  </strong>
                  .{" "}
                  <em>International Journal of Fauna and Biological Studies</em>{" "}
                  <strong>7</strong>(4): 196-198.
                </li>
                <li>
                  Griffiths D. 2006.{" "}
                  <strong>
                    The direct contribution of fish to lake phosphorus cycles
                  </strong>
                  . <em>Ecology of Freshwater Fish</em> <strong>15</strong>:
                  86-95.
                </li>
                <li>
                  Gupta T and Dey M. 2017.{" "}
                  <strong>
                    Ichthyotherapy: Use of fishes as medicine by ethnic Karbi
                    people of Assam, India
                  </strong>
                  .{" "}
                  <em>
                    European Journal of Pharmaceutical and Medical Research
                  </em>{" "}
                  <strong>4</strong>(10): 341-343.
                </li>
                <li>
                  Islam M M and Hossain M M. 2017.{" "}
                  <strong>
                    Community dependency on the ecosystem services from the
                    Sundarbans mangrove wetland in Bangladesh
                  </strong>
                  . <em>In Wetland Science</em> <em>Springer</em>, pp. 301-316.
                </li>
                <li>
                  Kaggwa R, Hogan R and Hall B. 2009.{" "}
                  <strong>
                    Enhancing wetlands&rsquo; contribution to growth, employment
                    and prosperity
                  </strong>
                  .<em> Environment and Natural Resources Report Series</em>{" "}
                  1-73.
                </li>
                <li>
                  Kakoti D, Phukan M M and Devi N B. 2019.{" "}
                  <strong>
                    Assessment of provisioning ecosystem services of Satajan
                    wetland and bird sanctuary, Lakhimpur district, Assam, India
                  </strong>
                  . <em>Environmentalism</em> <strong>4</strong>(1): 124-136.
                </li>
                <li>
                  Kalita G. 2019.
                  <strong>
                    {" "}
                    Biomass and rate of carbon sequestration by aquatic
                    macrophytes in Deepor (Beel) wetland - A Ramsar site
                  </strong>
                  . <em>
                    International Journal of Basic and Applied Research
                  </em>{" "}
                  <strong>9</strong>(1): 492-506.
                </li>
                <li>
                  Kant R, Haq S, Srivastava H C. <em>et al</em>{" "}
                  <strong>
                    Review of the bioenvironmental methods for malaria control
                    with special reference to the use of larvivorous fishes and
                    composite fish culture in central Gujarat, India
                  </strong>
                  . <em>Journal of Vector Borne Diseases</em>{" "}
                  <strong>50</strong>
                  (1): 1-12.
                </li>
                <li>
                  Kaul R, Masoodi A, Rasool A. <em>et al</em>{" "}
                  <strong>
                    Economic feasibility of willow removal from Wular Lake,
                    Jammu &amp; Kashmir
                  </strong>
                  .{" "}
                  <em>
                    The Economics of Ecosystems and Biodiversity India
                    Initiative
                  </em>{" "}
                  GIZ India, pp. 1-52.
                </li>
                <li>
                  Khan M I, Shin J H and Kim J D. 2018a.{" "}
                  <strong>
                    The promising future of microalgae: Current status,
                    challenges, and optimization of a sustainable and renewable
                    industry for biofuels, feed, and other products
                  </strong>
                  . <em>Microbial Cell Factories</em> <strong>17</strong>(1):
                  1-21.
                </li>
                <li>
                  Khan Z R, Chowdhury N S, Sharmin S. <em>et al</em>{" "}
                  <strong>
                    Medicinal values of aquatic plant genus Nymphoides grown in
                    Asia: A review
                  </strong>
                  . <em>Asian Pacific Journal of Tropical Biomedicine</em>{" "}
                  <strong>8</strong>(2): 113 - 119.
                </li>
                <li>
                  Kiran B R, Hamsa A and Puttaiah E T. 2007.{" "}
                  <strong>
                    Aquatic and marshy plants and their economic importance in
                    Bhadra reservoir project region, Karnataka
                  </strong>
                  . <em>Nature Environment and Pollution Technology</em>{" "}
                  <strong>6</strong>(3): 429.
                </li>
                <li>
                  Kulkarni V and Ramachandra T V. 2006.{" "}
                  <strong>
                    <em>Environmental Management</em>
                  </strong>
                  . The Energy and Resources Institute (TERI).
                </li>
                <li>
                  Lambert A. 2003.{" "}
                  <strong>
                    Economic valuation of wetlands: An important component of
                    wetland management strategies at the river basin scale
                  </strong>
                  . <em>Conservation Finance Guide, </em> 1-10. Washington.
                </li>
                <li>
                  Lannas K S and Turpie J K. 2009.{" "}
                  <strong>
                    Valuing the provisioning services of wetlands: Contrasting a
                    rural wetland in Lesotho with a peri-urban wetland in South
                    Africa
                  </strong>
                  . <em>Ecology and Society</em> <strong>14</strong>(2).
                </li>
                <li>
                  Li T and Gao X. 2016.{" "}
                  <strong>
                    Ecosystem services valuation of lakeside wetland park beside
                    Chaohu Lake in China
                  </strong>
                  . <em>Water</em> <strong>8</strong>(7): 1-19.
                </li>
                <li>
                  Magalh&atilde;es Filho L N L, Roebeling P C, Bastos M I.{" "}
                  <em>et al</em>{" "}
                  <strong>
                    A global meta-analysis for estimating local ecosystem
                    service value functions
                  </strong>
                  . <em>Preprints</em>, pp. 1-19.
                </li>
                <li>
                  Mahlatini P, Hove A, Maguma L F. <em>et al</em>{" "}
                  <strong>
                    Using direct use values for economic valuation of wetland
                    ecosystem services: a case of Songore wetland, Zimbabwe
                  </strong>
                  . <em>GeoJournal</em> <strong>85</strong>(1): 41-51.
                </li>
                <li>
                  2003.{" "}
                  <strong>
                    Ecosystems and human well-being: A framework for assessment
                  </strong>
                  . <em>Island Press: Washington</em>, pp. 1-266. USA.
                </li>
                <li>
                  Mishra P P. 2014.{" "}
                  <strong>
                    Potential benefits and earnings from improving the Hussain
                    Sagar Lake in Hyderabad: A combined revealed and stated
                    preference approach
                  </strong>
                  .{" "}
                  <em>
                    South Asian Network for Development and Environmental
                    Economics
                  </em>
                  , pp. 1-40.
                </li>
                <li>
                  Misra M K, Panda A and Sahu D. 2012.{" "}
                  <strong>
                    Survey of useful wetland plants of South Odisha, India
                  </strong>
                  . <em>Indian Journal of Traditional Knowledge</em>{" "}
                  <strong>11</strong>(4): 658-666.
                </li>
                <li>
                  Mukherjee S. 2008.{" "}
                  <strong>
                    Economic valuation of a wetland in West Bengal, India
                  </strong>
                  .{" "}
                  <em>
                    International Water Management Institute (IWMI)-TATA Water
                    Policy Research Programme
                  </em>
                  , pp. 1-14.
                </li>
                <li>
                  Najar I A and Khan A B. 2012.{" "}
                  <strong>
                    Assessment of water quality and identification of pollution
                    sources of three lakes in Kashmir, India, using multivariate
                    analysis
                  </strong>
                  . <em>Environmental Earth Sciences</em> <strong>66</strong>
                  (8): 2367-2378.
                </li>
                <li>
                  Nandan K B and Singh C B. 2004.{" "}
                  <strong>
                    Useful macrophytes in Kawar Lake, North Bihar, India
                  </strong>
                  . <em>Indian Journal of Forestry</em> <strong>27</strong>(3):
                  241-244.
                </li>
                <li>
                  Pandey J S, Joseph V and Kaul S N. 2004.{" "}
                  <strong>
                    A zone-wise ecological-economic analysis of Indian wetlands
                  </strong>
                  . <em>Environmental Monitoring and Assessment</em>{" "}
                  <strong>98</strong>(1): 261-273.
                </li>
                <li>
                  Peel R A, Hill J M, Taylor G C. <em>et al</em>{" "}
                  <strong>
                    Food web structure and trophic dynamics of a fish community
                    in an ephemeral floodplain lake
                  </strong>
                  . <em>Frontiers in Environmental Science</em>{" "}
                  <strong>7</strong>: 192.
                </li>
                <li>
                  Prakash S and Prakash S. 2021.{" "}
                  <strong>
                    Ethnomedicinal use of fishes by tribal communities in India:
                    A review
                  </strong>
                  . <em>The Pharma Innovation Journal</em> <strong>10</strong>
                  (5): 1315-1321.
                </li>
                <li>
                  Prasher R S, Negi Y S and Kumar V. 2006.{" "}
                  <strong>
                    Valuation and management of wetland ecosystem (a case study
                    of Pong Dam in Himachal pradesh)
                  </strong>
                  . <em>Man &amp; Development</em>, pp.77-92.
                </li>
                <li>
                  Quintas-Soriano C, Mart&iacute;n-L&oacute;pez B,
                  Santos-Mart&iacute;n F. <em>et al</em>{" "}
                  <strong>
                    Ecosystem services values in Spain: A meta-analysis
                  </strong>
                  . <em>Environmental Science &amp; Policy</em>{" "}
                  <strong>55</strong>: 186-195.
                </li>
                <li>
                  Ramachandra T V and Sreekantha R. 2006.{" "}
                  <strong>
                    Conservation values of wetlands in Sharavathi River Basin
                  </strong>
                  <em>. Pollution Research</em> <strong>25</strong>(1): 61-66.
                </li>
                <li>
                  Ramachandra T V, Alakananda B, Ali Rani. e<em>t al</em>{" "}
                  <strong>
                    Ecological and socio-economic assessment of Varthur wetland,
                    Bengaluru (India)
                  </strong>
                  . <em>Journal of Environmental Science and Engineering</em>{" "}
                  <strong>53</strong>(1): 101-108.
                </li>
                <li>
                  Ramachandra T V, Asulabha K S and Lone A A. 2014.{" "}
                  <strong>
                    Nutrient enrichment and proliferation of invasive
                    macrophytes in urban lakes
                  </strong>
                  . <em>Journal of Biodiversity</em> <strong>5</strong>(1-2):
                  33-44.
                </li>
                <li>
                  Ramachandra T V, Asulabha K S and Sincy V. 2021.{" "}
                  <strong>
                    Phosphate loading and foam formation in urban lakes
                  </strong>
                  . <em>G P Globalize Research Journal of Chemistry</em>{" "}
                  <strong>5</strong>(1): 33-52.
                </li>
                <li>
                  Ramachandra T V, Asulabha K S, Sincy V. <em>et al</em>.{" "}
                  <strong>Wetlands: Treasure of Bangalore</strong>.{" "}
                  <em>ENVIS Technical Report 101</em>, EWRG, CES, Indian
                  Institute of Science, Bangalore.
                </li>
                <li>
                  Ramachandra T V, Raj R K, and Aithal B H. 2019.{" "}
                  <strong>
                    Valuation of Aghanashini estuarine ecosystem goods and
                    services
                  </strong>
                  . <em>Journal of Biodiversity</em> <strong>10</strong>(1-2):
                  45-58.
                </li>
                <li>
                  Ramachandra T V, Rajinikanth R and Ranjini V G. 2005.{" "}
                  <strong>Economic valuation of wetlands</strong>.{" "}
                  <em>Journal of Environmental Biology</em> <strong>26</strong>
                  (2): 439-447.
                </li>
                <li>
                  Ramachandra T V, Sincy V and Asulabha K S. 2020a.{" "}
                  <strong>
                    Efficacy of rejuvenation of lakes in Bengaluru, India
                  </strong>
                  . <em>Green Chemistry &amp; Technology Letters</em>{" "}
                  <strong>6</strong>(1): 14-26.
                </li>
                <li>
                  Ramachandra T V, Sincy V, Asulabha K S. <em>et al</em>{" "}
                  <strong>
                    Optimal treatment of domestic wastewater through constructed
                    wetlands
                  </strong>
                  . <em>Journal of Biodiversity </em>
                  <strong>9</strong>(1-2): 81-102.
                </li>
                <li>
                  Ramachandra T V, Sudarshan P, Vinay S. <em>et al</em>{" "}
                  <strong>
                    Nutrient and heavy metal composition in select biotic and
                    abiotic components of Varthur wetlands, Bangalore, India
                  </strong>
                  . <em>SN Applied Sciences</em> <strong>2</strong>(8): 1-14.
                </li>
                <li>
                  Ramachandra T V. 2016.{" "}
                  <strong>
                    Valuation of goods and services from forests ecosystem of
                    Uttara Kannada, Central Western Ghats
                  </strong>
                  . <em>ENVIS Bulletin Himalayan Ecology</em>{" "}
                  <strong>24</strong>: 1-25.
                </li>
                <li>
                  Rao C S. 2018.{" "}
                  <strong>
                    Economic analysis of wetland ecosystems and their
                    conservation and management: The case of Kuttanad coastal
                    wetland ecosystem of Kerala
                  </strong>
                  . <em>Doctoral dissertation</em>, TNAU, Coimbatore.
                </li>
                <li>
                  Rao G R, Mesta D K, Chandran M S. <em>et al</em>{" "}
                  <strong>Wetland flora of Uttara Kannada</strong>.{" "}
                  <em>
                    Environmental Education for Ecosystem Conservation. New
                    Delhi: Capital Publishing Company
                  </em>
                  , pp. 140-152.
                </li>
                <li>
                  Ro C, Sovann C, Bun D. <em>et al</em>{" "}
                  <strong>
                    The economic value of peri-urban wetland ecosystem services
                    in Phnom Penh, Cambodia
                  </strong>
                  .{" "}
                  <em>
                    In IOP Conference Series: Earth and Environmental Science
                  </em>{" "}
                  <strong>561</strong>(1): 1-8.
                </li>
                <li>
                  Roebeling P, Abrantes N, Ribeiro S. <em>et al</em>
                  <strong>
                    {" "}
                    Estimating cultural benefits from surface water status
                    improvements in freshwater wetland ecosystems
                  </strong>
                  . <em>Science of the Total Environment</em>{" "}
                  <strong>545</strong>: 219-226.
                </li>
                <li>
                  Russi D, ten Brink P, Farmer A. <em>et al</em>{" "}
                  <strong>
                    The economics of ecosystems and biodiversity for water and
                    wetlands
                  </strong>
                  . <em>IEEP</em>, London and Brussels; Ramsar Secretariat,
                  Gland, pp. 1-84.
                </li>
                <li>
                  S&aacute;nchez‐Baracaldo P and Cardona T. 2020.{" "}
                  <strong>
                    On the origin of oxygenic photosynthesis and cyanobacteria
                  </strong>
                  . <em>New Phytologist</em> <strong>225</strong>(4): 1440-1446.
                </li>
                <li>
                  Sarma S K and Saikia M. 2010.{" "}
                  <strong>
                    Utilization of wetland resources by the rural people of
                    Nagaon district, Assam
                  </strong>
                  . <em>Indian Journal of Traditional Knowledge</em>{" "}
                  <strong>9</strong>(1): 145-151.
                </li>
                <li>
                  Schuijt K. 2002.{" "}
                  <strong>
                    Land and water use of wetlands in Africa: Economic values of
                    African wetlands
                  </strong>
                  . <em>IIASA Interim Report</em>, pp. 1-48.
                </li>
                <li>
                  Schuyt K and Brander L. 2008.{" "}
                  <strong>
                    The economic values of the world&rsquo;s wetlands
                  </strong>
                  .{" "}
                  <em>
                    Prepared with support from the Swiss Agency for the
                    Environment, Forests and Landscape (SAEFL)
                  </em>
                  . Gland/Amsterdam, pp. 1-32.
                </li>
                <li>
                  SEEA EEA. 2014.{" "}
                  <strong>
                    System of Environmental-Economic Accounting 2012:
                    Experimental Ecosystem Accounting
                  </strong>
                  , pp. 1-198. United Nations, New York.
                </li>
                <li>
                  SEEA EEA. 2021.{" "}
                  <strong>
                    System of Environmental-Economic Accounting: Ecosystem
                    accounting
                  </strong>
                  , <em>Final draft</em>, pp. 1-362. United Nations, New York.
                </li>
                <li>
                  Sharma B, Rasul G and Chettri N. 2015.{" "}
                  <strong>
                    The economic value of wetland ecosystem services: Evidence
                    from the KoshiTappu Wildlife Reserve, Nepal
                  </strong>
                  . <em>Ecosystem Services</em> <strong>12</strong>: 84-93.
                </li>
                <li>
                  Sincy V, Asulabha K S, Jaishanker R. <em>et al</em>{" "}
                  <strong>
                    Ichthyo-diversity in sewage fed lentic ecosystems of
                    Bangalore
                  </strong>
                  . Paper presented at the <em>Conference on</em>{" "}
                  <em>ICWR-2018</em>, Dept. of Environmental Sciences &amp;
                  Dept. of Geology University of Kerala, Trivandrum, India.
                </li>
                <li>
                  Sincy V, Jaishanker R, Asulabha K S. <em>et al</em>{" "}
                  <strong>
                    Ichthyofauna diversity in relation to water quality of lakes
                    of Bangalore, Karnataka
                  </strong>
                  . <em>Biodiversity Challenges &ndash; A Way Forward</em>, pp.
                  115-146. Daya Publishing House, New Delhi.
                </li>
                <li>
                  Taran M and Deb S. 2020.{" "}
                  <strong>
                    Utilization pattern of macrophytes in Rudrasagar Lake, a
                    Ramsar site in India
                  </strong>
                  . <em>Applied Ecology and Environmental Sciences</em>{" "}
                  <strong>8</strong>(4): 179-186.
                </li>
                <li>
                  Taran M, Deb S and Roy J. 2016.
                  <strong>
                    {" "}
                    Physico-chemical characteristics, biodiversity assessment
                    and economic valuation of Kalyanthakur Para lake: A
                    community based lake of Tripura, North-East India
                  </strong>
                  . <em>Lakes, Reservoirs and Ponds</em> <strong>10</strong>(2):
                  96-109.
                </li>
                <li>
                  TEEB (The Economics of Ecosystems and Biodiversity) Ecological
                  and Economic Foundations Earthscan London. 2010.
                </li>
                <li>
                  Thapa S, Wang L, Koirala A. <em>et al</em>{" "}
                  <strong>
                    Valuation of ecosystem services from an important wetland of
                    Nepal: A Study from Begnas watershed system
                  </strong>
                  . <em>Wetlands</em> <strong>40</strong>(5): 1071-1083.
                </li>
                <li>
                  Tursi A, Maiorano P, Sion L. <em>et al</em>{" "}
                  <strong>
                    Fishery resources: Between ecology and economy
                  </strong>
                  . <em>Rendiconti Lincei</em> <strong>26</strong>(1): 73-79.
                </li>
                <li>
                  Vanni M J. 2002.{" "}
                  <strong>
                    Nutrient cycling by animals in freshwater ecosystems.
                  </strong>{" "}
                  <em>Annual Review of Ecology, Evolution, and Systematics</em>{" "}
                  <strong>33</strong>: 341&ndash;370.
                </li>
                <li>
                  Venkatachalam L and Zareena Begam I. 2016.{" "}
                  <strong>
                    Economic valuation of ecosystem services: A case study of
                    Ousteri wetland, Puducherry
                  </strong>
                  .{" "}
                  <em>
                    The Economics of Ecosystems and Biodiversity India
                    Initiative
                  </em>
                  , pp. 1-103. GIZ India.
                </li>
                <li>
                  Verma M, Bakshi N and Nair R P. 2001.{" "}
                  <strong>
                    Economic valuation of Bhoj wetland for sustainable use
                  </strong>
                  . <em>Indian Institute of Forest Management, Bhopal</em>, pp.
                  1-227.
                </li>
                <li>
                  Verma M, Negandhi D, Wahal A K. <em>et al</em>{" "}
                  <strong>
                    Revision of rates of NPV applicable for different
                    class/category of forests
                  </strong>
                  .{" "}
                  <em>Indian Institute of Forest Management, Bhopal, India</em>,
                  pp. 1-165.
                </li>
                <li>
                  Yang F, Hanna M A and Sun R. 2012.
                  <strong>
                    {" "}
                    Value-added uses for crude glycerol - A byproduct of
                    biodiesel production
                  </strong>
                  . <em>Biotechnology for Biofuels</em> <strong>5</strong>(1):
                  1-10.
                </li>
                <li>
                  Yiran Z, Demin Z, Zhenguo N. <em>et al</em>{" "}
                  <strong>
                    Valuation of lake and marsh wetlands ecosystem services in
                    China
                  </strong>
                  . <em>Chinese Geographical Science</em> <strong>24</strong>
                  (3): 269-278.
                </li>
                <li>
                  Zang S, Wu C, Liu H. <em>et al</em>{" "}
                  <strong>
                    Impact of urbanization on natural ecosystem service values:
                    A comparative study
                  </strong>
                  . <em>Environmental Monitoring and Assessment</em>{" "}
                  <strong>179</strong>(1): 575-588.
                </li>
                <li>
                  Zarandi M T P, Abesht A, Abedi S. <em>et al</em>{" "}
                  <strong>
                    The estimation of economic value of wetland ecosystem
                    protection and recreational services: Case study of the
                    Kanibrazan international wetland
                  </strong>
                  . <em>Journal of Materials and Environmental Sciences</em>{" "}
                  <strong>10</strong>(11): 1172-1184.
                </li>
                <li>
                  Zhang P, He L, Fan X. <em>et al</em>{" "}
                  <strong>
                    Ecosystem service value assessment and contribution factor
                    analysis of land use change in Miyun County, China
                  </strong>
                  . <em>Sustainability</em> <strong>7</strong>(6): 7333-7356.
                </li>
                <li>
                  Zhang Y, Xu H, Chen H. <em>et al</em>{" "}
                  <strong>
                    Diversity of wetland plants used traditionally in China: A
                    literature review
                  </strong>
                  . <em>Journal of Ethnobiology and Ethnomedicine</em>{" "}
                  <strong>10</strong>(1): 1-19.
                </li>
                <li>
                  Zuze S. 2013.{" "}
                  <strong>
                    Measuring the economic value of wetland ecosystem services
                    in Malawi: A case study of lake Chiuta wetland
                  </strong>
                  . <em> Thesis, University of Zimbabwe</em>, pp. 1-93.
                </li>
              </ol>
            </p>
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default ReferencesPage;
